import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-emergency',
	templateUrl: './icon-emergency.component.svg',
})
export class IconEmergencyComponent {}
